import * as React from 'react'
import {} from 'react'
import {
  BulkActionsFooter,
  BulkActionsLabel,
  BulkActionsProps,
  SelectedRowCount,
} from '@user/components/xGrid'
import { useBulkActionLabels } from './useBulkActionLabels'

export const OpportunityBulkActionFooter: React.FC<BulkActionsProps> = ({
  selectedRows,
}) => {
  const { avgAge, totalValue } = useBulkActionLabels(selectedRows)

  return (
    <BulkActionsFooter>
      <SelectedRowCount count={selectedRows.size} />
      <BulkActionsLabel label={avgAge} />
      <BulkActionsLabel label={totalValue} />
    </BulkActionsFooter>
  )
}
OpportunityBulkActionFooter.displayName = 'OpportunityBulkActionFooter'
